/**
 * アプリケーション例外の共通ハンドリング
 */
import _Vue from 'vue'

// アプリケーション定義例外のimport
import {
  StudentAuthAppError,
  ApiBadRequestAppError,
  ApiNotFoundAppError,
  ApiRequireResetPasswordAppError,
  ApiConflictAppError,
  ApiLockedAppError,
} from '@/models/AppErrorClasses'

export default {
  /**
   * plugin登録時に実行される処理
   *
   * @param Vue Vueのコンストラクタ
   */
  install(Vue: typeof _Vue): void {
    /**
     * エラーハンドラ
     *
     * @param err 例外情報
     */
    const handler = (err: unknown): void => {
      // エラーの種類ごとに処理分岐
      if (err instanceof StudentAuthAppError) {
        // 認証エラー(生徒権限)
        //   ログイン情報を破棄してログイン画面に遷移
        Vue.prototype.$appCookies.removeAuth()
        window.location.href = '/student/login'
      } else if (err instanceof ApiRequireResetPasswordAppError) {
        // APIパスワード変更要求エラー

        // 生徒ログイン情報が存在する場合は生徒用パスワード変更画面に遷移
        try {
          // 生徒ログイン情報を取得(存在しない場合は例外が発生する)
          Vue.prototype.$appCookies.authStudent.get()
          window.location.href = '/student/password'
          return
        } catch {
          // 例外発生=生徒ログイン情報がない
        }

        // それ以外の場合は401エラー画面に遷移(発生しない想定だがブロックのため)
        window.location.href = '/error/401'
      } else if (err instanceof ApiBadRequestAppError) {
        // API400エラー(キャッチされなかった場合)
        window.location.href = '/error/400'
      } else if (err instanceof ApiNotFoundAppError) {
        // API404エラー(キャッチされなかった場合)
        window.location.href = '/error/404'
      } else if (err instanceof ApiConflictAppError) {
        // API409エラー(キャッチされなかった場合)
        window.location.href = '/error/409'
      } else if (err instanceof ApiLockedAppError) {
        // API423エラー(キャッチされなかった場合)
        window.location.href = '/error/423'
      }
    }

    // Vue.jsのエラーハンドラ設定
    Vue.config.errorHandler = (err: unknown): void => {
      handler(err)
    }

    // Vue.js以外のエラーハンドラ設定
    window.addEventListener('error', (event) => {
      handler(event.error)
    })

    // Promise経由で呼び出されるエラーハンドラ設定(Promise.reject)
    window.addEventListener('unhandledrejection', (event) => {
      handler(event.reason)
    })
  },
}
